export default {
  text_placeholder: 'Введите сообщение...',
  attach: {
    attach_image: {
      btn_select: 'Прикрепить изображение',
      title: 'Выберите изображение',
      dropzone: {
        description: '<p>Вы можете загрузить изображение, удовлетворяющее требованиям:</p><p>Максимальный размер изображения 1600x1200px, до 2Мб.</p><p>Или выбрать из галереи ранее загруженных изображений.</p>',
      },
    },
    attach_video: {
      btn_select: 'Прикрепить видео',
      title: 'Выберите видео',
      dropzone: {
        description: '<p>Вы можете загрузить видео, удовлетворяющее требованиям:</p><p>Размер видеофайла до 200 Мб, формат 3gp, m4v, mov, mp4.</p><p>Или выбрать из ранее загруженных видео.</p>',
      },
    },
    attach_document: {
      btn_select: 'Прикрепить документ',
      title: 'Выберите документ',
      dropzone: {
        description: '<p>Вы можете загрузить видео, удовлетворяющее требованиям:</p><p>Размер видеофайла до 200 Мб, формат 3gp, m4v, mov, mp4.</p><p>Или выбрать из ранее загруженных видео.</p>',
      },
      upload_description: {
        viber: 'Вы можете загрузить файл, удовлетворяющий требованиям:<br>' +
          'Максимальный размер файла 200Мб<br>' +
          'Расширение файла: .doc, .docx, .rtf, .dot, .dotx, .odt ,odf, .fodt, .txt, .info, .pdf, .xps, .pdax, .eps, .xls, .xlsx, .ods, .fods, .csv, .xlsm, .xltx',
        whatsapp: 'Вы можете загрузить файл, удовлетворяющий требованиям:<br>' +
          'Максимальный размер файла 100Мб',
      },
    },
    modal: {
      title: 'Прикрепить файл',
      description: 'Выберите или загрузите файл для прикрепления к сообщению.',
      btn_upload: 'Загрузить',
      empty_description: 'Отсутствуют изображения в галерее Вашего аккаунта.<br> Загрузите изображение удовлетворяющее требованиям канала рассылки.',
      empty_video_description: 'Отсутствуют видео в галерее Вашего аккаунта.<br> Загрузите видео удовлетворяющее требованиям канала рассылки.',
      empty_document_description: 'Отсутствуют документы в галерее Вашего аккаунта.<br> Загрузите документ удовлетворяющее требованиям канала рассылки.',
    },
  },
  fast_answers: {
    more: 'Больше',
  },
  reassign: {
    start_chatting: 'Начать общение',
    assign_to_user: 'Назначить на пользователя...',
  },
};
